import { render, staticRenderFns } from "./VatNumber.vue?vue&type=template&id=356dff97&"
import script from "./VatNumber.vue?vue&type=script&lang=ts&"
export * from "./VatNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports